template = require('./country_options.html.slim')
controller = require('./country_options_controller')

# Superseded by ng2 CountryListComponent (selector: input-countrylist)
angular.module('wbComponents').directive 'wbCountryOptions', ->
  scope:
    noSelectText: '='
  restrict: 'E'
  replace: true
  require: '?ngModel'
  templateUrl: template
  controller: controller
  controllerAs: 'ctrl'
